/** Local object URLs for freshly uploaded images, so message bubbles show thumbnails instantly. */
const previews = new Map<string, string>();

export function rememberPreview(attachmentId: string, url: string): void {
  previews.set(attachmentId, url);
}

export function getPreview(attachmentId: string): string | undefined {
  return previews.get(attachmentId);
}
